export const MercedesCloseIcon = (props) => (
    <svg width={props.size || 20} height={props.size || 20} viewBox="0 0 24 24" fill="none" stroke="none" xmlns="http://www.w3.org/2000/svg"{...props}>
        <path d="M23 23L1 1M23 1L1 23" stroke="#414141" stroke-width="2" stroke-linecap="round" />
    </svg>
);


